export default __webpack_public_path__ + "static/media/cert-fsi-hkgcsmeaa-sc.72df1047.jpg";